<div class="workSpace">
  <div class="headersTab">
    <div class="w3-quarter padreizquierda">
      <div class="w3-row hijoizquierda">
        <span class="w3-text-deep-orange w3-margin-right-filter w3-tituloPrincipal"> <b> {{ "menu." +
            dataService.moduleSelect | translate }} </b> </span>
        <span class="w3-text-deep-orange">&bull;</span>
        <span class="w3-text-orange w3-margin-left-filter w3-subtituloPrincipal"> {{ "menu." +
          dataService.subModuleSelect | translate }} </span>
      </div>
    </div>
    <!-- Filtros -->
    <div class="w3-rest">
      <div class="w3-noventa2 w3-row">
        <div class="w3-third padreizquierda" [ngClass]="{'w3-disabled': monthSelect}">
          <app-filters 
            [name]="'filtros.anio' | translate" 
            [array]="yearsAvailable" 
            [typeFilter]="Filters.YEAR"
            (eventClick)="yearChange($event)" 
            [click]="false">
          </app-filters>
        </div>
        <div class="w3-third padreizquierda" [ngClass]="{'w3-disabled': monthSelect}">
          <app-filters 
            [name]="'filtros.anio' | translate" 
            [array]="periodicidad" 
            [typeFilter]="Filters.PERSPECTIVES"
            (eventClick)="periodicityChange($event)" 
            [click]="false">
          </app-filters>
        </div>
        <div class="w3-third padreizquierda" [ngClass]="{'w3-disabled': monthSelect}">
          <app-filters 
            [name]="'filtros.sucursales' | translate" 
            [array]="sucursales" [typeFilter]="Filters.SUCURSALES"
            [click]="false"
            [consolidado]="consolidado" 
            (eventClick)="sucursalChange($event)">
            <!-- (eventClick)="periodicityChange($event)" -->
          </app-filters>
        </div>
      </div>
      <div class="w3-rest padreizquierda w3-right" style="height: 7vh; padding-top: 2vh; z-index: 100;">
        <div class="w3-button w3-dropdown-click" style="transform: scale(0.9);" [ngStyle]="{'color':'gray'}" (click)="resetFilters()"
          matTooltip="{{'tooltips.borrar-filtros'|translate}}">
          <img src="./../../../../assets/img/eraser.png">
        </div>
        <mat-icon class="w3-row w3-rigth w3-button iconoMen" [ngStyle]="{'color':'gray'}"
        [matMenuTriggerFor]="menu">
          more_vert
        </mat-icon>
        <mat-menu #menu="matMenu">
          <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="exportarPDF()">
            <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
            <span>{{'menu.Exportar'|translate}}</span>
          </button>
          <!-- <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" (click)="exportarExcelSucursales()">
            <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
            <span>{{'menu.exportar-suc'|translate}}</span>
          </button> -->
        </mat-menu>
      </div>
    </div>
  </div>
  <div class="workSpaceTab">
    <div class="zona1">
      <div class="subZona1">
        <app-graficas [data]="data1" [type]="types.COMBO" [labels]="labels1" [axisY]="axisY1" [tituloZona]="tituloZona1"
          [graphicsAvaibable]="graphics1" [zona]="zona1" [subTituloZona]="subtitles1"
          [perspectivesAvaibable]="perspectives" (eventClick)="clickGraphicPrincipal($event)">
        </app-graficas>
      </div>
      <div class="subZona2">
        <div class="w3-row">
          <div class="zonaHeader w3-titulo-contenidomenuSC w3-threequarter">
            <span class="w3-margin-left-contenido">{{tituloZona2|translate}}</span>
            <span class="w3-margin-left-contenido">&bull;</span>
            <span class="w3-margin-left-filter w3-subtitulo" matTooltip="{{subtitles2}}">{{subtitles2}}</span>
          </div>
          <div class="w3-rest w3-right">
            <mat-icon class="w3-row w3-rigth w3-button iconoMen" [ngStyle]="{'color':'gray'}" (click)="openModal()">
              zoom_out_map
            </mat-icon>
            <mat-icon class="w3-row w3-rigth w3-button iconoMen" [ngStyle]="{'color':'gray'}"
              [matMenuTriggerFor]="menu1">
              more_vert
            </mat-icon>
            <mat-menu #menu1="matMenu">
              <button class="mat-menu-item" mat-menu-item class="w3-caja-menu">
                <mat-icon [ngStyle]="{'color':'gray'}">image</mat-icon>
                <span>{{'acciones.exportar' | translate}}</span>
              </button>
              <button class="mat-menu-item" mat-menu-item class="w3-caja-menu" [matMenuTriggerFor]="">
                <mat-icon [ngStyle]="{'color':'gray'}">assessment</mat-icon>
                <span>{{'acciones.perspectivas' | translate}}</span>
              </button>
            </mat-menu>
          </div>
        </div>
        <div class="zonaTable w3-scroll">
          <table class="w3-table" style="margin-bottom: 1vh;">
            <thead>
              <tr class="w3-center w3-table-title">
                <th class="stikyColum w3-border-right-balance w3-border-top-balance">
                  {{'comercial.captacion.tendencia.titulo-encabezado-2-1' | translate}}</th>
                @for (item of productos; track $index) {
                <th class="stikyColum w3-border-right-balance w3-border-top-balance">
                  {{item}}
                </th>
                }
              </tr>
            </thead>
            <tbody>
              @for (d of data2; track $index) {
              <tr class="w3-table-trtd">
                <td class="borderAllLow"> {{d.sucursal}} </td>
                @for (p of productos; track $index) {
                <td class="borderAllLow marginDer alinRight">
                  {{formaters(d[p], 'decimales')}}
                </td>
                }
              </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <div class="zona2">
      @for (item of Tarjets; track $index) {
      <div class="zonaTarjetas">
        <app-tarjetas [icon]="''"></app-tarjetas>
      </div>
      }
    </div>
  </div>
</div>

<div id="table-modal" class="modal" (click)="clickFueraP($event)">
  <div class="modalContent" style="width: 80%;">
    <div class="w3-row">
      <div class="w3-row w3-noventa2 w3-white">
        <div class="w3-row  w3-header-cuadrante padreizquierda"
          style="height: 6vh; margin-top: 10px; margin-left: 20px">
          <div class="w3-noventa2 w3-titulo-contenidomenu bottom hijoizquierdaTitle">
            <span class="modal-title">{{tituloZona2|translate}}</span>
          </div>
        </div>
      </div>
      <div class="w3-rest w3-right w3-white" style="height: 6vh; margin-top: 10px;">
        <div class="w3-row" style="height: 3vh; transform: translate(0, 40%);">
          <mat-icon class="w3-margin-right-contenido w3-button w3-dropdown-click"
            (click)="closeModal()">clear</mat-icon>
        </div>
      </div>
    </div>
    <div class="modal-body">
      <div class="zonaTable w3-scroll">
        <table class="w3-table" style="margin-bottom: 1vh;">
          <thead>
            <tr class="w3-center w3-table-title">
              <th class="stikyColum w3-border-right-balance w3-border-top-balance">
                {{'comercial.captacion.tendencia.titulo-encabezado-2-1' | translate}}
              </th>
              @for (item of productos; track $index) {
                <th class="stikyColum w3-border-right-balance w3-border-top-balance">
                  {{item}}
                </th>
              }
            </tr>
          </thead>
          <tbody>
            @for (d of data2; track $index) {
              <tr class="w3-table-trtd">
                <td class="borderAllLow"> {{d.sucursal}} </td>
                @for (p of productos; track $index) {
                  <td class="borderAllLow marginDer alinRight">
                    {{formaters(d[p], 'decimales')}}
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>